module.exports = __webpack_public_path__ + "img/epay_Cert_005.ee41630e.png";